/**
 * Wishlist System — localStorage-based, login-gated
 * Namespace: window.Instocks
 */
(function () {
  'use strict';

  window.Instocks = window.Instocks || {};

  const STORAGE_KEY = 'instocks_wishlist';

  /**
   * @returns {string[]} Array of product ID strings
   */
  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw === null) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * @param {string[]} data
   */
  function saveWishlist(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      // localStorage may be full or disabled — fail silently
    }
  }

  /**
   * Sync all wishlist buttons on the page with the current state
   */
  function syncAllButtons() {
    var wishlist = getWishlist();
    /** @type {NodeListOf<HTMLElement>} */
    var buttons = document.querySelectorAll('.wishlist-btn[data-product-id]');

    buttons.forEach(function (btn) {
      var productId = btn.dataset.productId;
      if (!productId) return;

      const isInWishlist = wishlist.indexOf(productId) > -1;
      btn.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
      if (isInWishlist) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  /**
   * Handle click – toggle product in wishlist
   * @param {Event} e
   */
  function handleClick(e) {
    /** @type {HTMLElement|null} */
    var btn = /** @type {HTMLElement} */ (e.target);
    if (!btn) return;
    btn = btn.closest('.wishlist-btn[data-product-id]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var productId = btn.dataset.productId;
    if (!productId) return;

    var wishlist = getWishlist();
    var index = wishlist.indexOf(productId);

    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productId);
    }

    saveWishlist(wishlist);
    syncAllButtons();
  }

  document.addEventListener('click', handleClick);

  // Initial sync on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllButtons);
  } else {
    syncAllButtons();
  }

  // Re-sync after Shopify section rendering (theme editor & AJAX navigations)
  document.addEventListener('shopify:section:load', syncAllButtons);

  // Expose API for external use
  window.Instocks.wishlist = {
    get: getWishlist,
    save: saveWishlist,
    sync: syncAllButtons,
  };
})();
